module.exports = __webpack_public_path__ + "static/media/program_fr.ed4dceab.svg";